import { useTranslation } from 'react-i18next';
import { formatFullname } from '../../libraries/utils';
import logo from '../../assets/img/logo.png';
import { QRCodeCanvas } from 'qrcode.react';
import QRCode from 'qrcode.react';
import config from '../../config';

export default function PrescriptionPDFPrint({ htmlId, prescription, professional, patient, date, ...rest }) {
  const { t, i18n } = useTranslation();
  let licenses = professional?.license
  if(professional?.license && Array.isArray(professional?.license)){
    licenses = licenses.slice(0,2).map(license => license.matricula);
    if(professional?.license.length > 2){
      licenses.push('2+');
    }
  }
  const debug = false
  const test_url = "https://innos-public-files.s3.amazonaws.com/d79cfc70-c014-4b32-8680-d0b933f1007b_signature_test_img_3.jpg" + "?t=" + new Date().getTime() 
  const prof_signature = professional.signature + "?t=" + new Date().getTime()
  const signature = debug ? test_url : prof_signature
  const prof_signature64 = professional.cover_image
  
  const medicament1 = prescription.prescriptions_lines.length > 0 ? prescription.prescriptions_lines[0].json_data.medicament : {}
  const medicament2 = prescription.prescriptions_lines.length > 1 ? prescription.prescriptions_lines[1].json_data.medicament : {}

  const diagnostic1 = prescription.diagnostics.length > 0 ? prescription.diagnostics[0] : {}
  const diagnostic2 = prescription.diagnostics.length > 1 ? prescription.diagnostics[1] : {}
  const duration = prescription.duration

  const prefix = professional.gender && professional.gender === 'femenino' ? 'Dra.' : 'Dr.';
  const duplicate = prescription?.duplicate

  const prescription_num = prescription.prescription_num.toString().padStart(8, '0');

  const link_qr = config.DOMAIN_NAME + "/verify_prescription/" + prescription.id;

  const [ specialty1, specialty2 ] = professional.specialty.split("_/_/_")
  const specialtyString = (specialty1 ?? "") + " - " + (specialty2 ?? "")

  const PrescriptionNoDup = () => {
    return (
      <>
        <div className="border-r-2 border-black pr-2 mr-2">
          <div className="border-b-2 border-black flex justify-between" >
            <div className='flex justify-between items-center'>
              <div className="flex flex-col justify-center pb-4">
                <img src={logo} alt="" width="50%" />
                <div className='flex'>
                  <p className="font-light uppercase mr-3">Prescripción:</p>
                  <h5 className="font-bold flex-1">{prescription_num}</h5>
                </div>
              </div>
              <div className='mr-5'>
                <QRCode 
                  className="p-4 mx-auto"
                  value={link_qr}
                  size={98}
                />
              </div>
            </div>
            <div className="flex justify-center shrink-0 flex-col border-l pl-4 my-2">
              <h5 className="text-primary">{prefix} {formatFullname(professional)} </h5>
              <p className="text-gray-500">Especialista en {specialtyString}</p>
              {licenses && <p className="text-gray-700 block">{(licenses[0] && `MP: ${licenses[0]}`)} - {(licenses[1] && `MP: ${licenses[1]}`)} {(licenses[2] && ` - ${licenses[2]}`)}</p>}
            </div>
          </div>
          <div className="">
            <div className="border-b border-black pb-2 flex items-center">
              <p className="font-light uppercase mr-3">Apellido y Nombres del afiliado</p>
              <h5 className="font-bold flex-1">{formatFullname(patient)}</h5>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="border-b border-black pb-2 flex items-center">
                <p className="font-light uppercase mr-3">Obra Social</p>
                <h5 className="font-bold flex-1">{patient.insurance_name}</h5>
              </div>
              <div className="border-b border-black pb-2 flex items-center">
                <p className="font-light uppercase mr-3">Afiliado</p>
                <h5 className="font-bold flex-1">{patient.insurance_number}</h5>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="border-b border-black pb-2 flex items-center">
                <p className="font-light uppercase mr-3">Fecha de emisión</p>
                <h5 className="font-bold flex-1">{date && date.toLocaleDateString()}</h5>
              </div>
              <div className="border-b border-black pb-2 flex w-full items-center">
                <p className="font-light uppercase mr-3">Duración</p>
                <h5 className="font-bold flex-1">{duration}</h5>
              </div>
            </div>
            <p className="font-light uppercase mr-3 mb-2">Medicamentos</p>
            <div className="border-b-2 border-black pb-2 h-14">
              <div className="flex items-stretch justify-between">
                <div className="flex">
                  <p className="font-light uppercase mr-3">RP./1</p>
                  <div>
                    <h5 className="font-bold">{medicament1.name}</h5>
                    <p className="font-light">{medicament1.drug}</p>
                    <p className="font-light">{medicament1.presentation}</p>
                    <p className="font-light italic mt-1">{medicament1.indications}</p>
                  </div>
                </div>
                <h5 className="font-bold"></h5>
                <div className="flex">
                  <p className="font-light mr-2">CANT.REC</p>
                  <h5 className="font-bold">{medicament1.quantity}</h5>
                </div>
              </div>
            </div>
            <div className="border-b-2 border-black pb-2 h-14">
              <div className="flex items-stretch justify-between">
                <div className="flex">
                  <p className="font-light uppercase mr-3">RP./2</p>
                  <div>
                    <h5 className="font-bold">{medicament2.name}</h5>
                    <p className="font-light">{medicament2.drug}</p>
                    <p className="font-light italic mt-1">{medicament2.indications}</p>
                  </div>
                </div>
                <h5 className="font-bold"></h5>
                <div className="flex">
                  <p className="font-light mr-2">CANT.REC</p>
                  <h5 className="font-bold">{medicament2.quantity}</h5>
                </div>
              </div>
            </div>
            <div className="flex border-b-2 border-black pb-2">
              <div className="w-3/5 border-r-2 border-black">
                <div className="border-b-2 border-black flex justify-items-start mr-2 pb-8 h-14">
                  <p className="font-light uppercase mr-2">Diagnóstico <br></br> RP./1</p>
                  <h5 className="font-bold">{diagnostic1.name}</h5>
                </div>
                <div className=" flex justify-items-start mr-2 pb-6 h-14">
                  <p className=" font-light uppercase mr-2">Diagnóstico<br></br> RP./2</p>
                  <h5 className="font-bold">{diagnostic2.name}</h5>
                </div>
              </div>
              <div className="flex justify-start items-center flex-col shrink-0 pl-4 pt-2">
                {professional.cover_image ? <img crossOrigin="anonymous" src={prof_signature64} alt="" width="150px" height="150px" /> : <div>Profesional sin firma</div>}
                <p className="font-bold">{prefix} {formatFullname(professional)}</p>
                <p>Especialista en {specialtyString}</p>
                  {licenses && <p className="text-gray-700 block">{(licenses[0] && `MP: ${licenses[0]}`)} - {(licenses[1] && `MP: ${licenses[1]}`)} {(licenses[2] && ` - ${licenses[2]}`)}</p>}
              </div>
            </div>
          </div>
        </div>
        <div className="troquel-section">
          {/*fixme:*/}
          {/*¿Para que pusimos un rectangulo que dice (decía) QR si lo vamos a poner arriba? */}
          {/*queda acá sacando una banda de espacio*/}
          <div className="w-full h-16 bg-gray-200 flex items-center justify-center">{/*QR*/}</div>
          <p className="border border-dashed border-black flex items-center justify-center w-full h-12 mb-2">
            Troquel
          </p>
          <p className="border border-dashed border-black flex items-center justify-center w-full h-12 mb-2">
            Troquel
          </p>
          <p className="border border-dashed border-black flex items-center justify-center w-full h-12 mt-2">
            Troquel
          </p>
          <p className="border border-dashed border-black flex items-center justify-center w-full h-12 mt-2">
            Troquel
          </p>
        </div>
      </>
    )
  }
  const PrescriptionDup = () => {
    return (
      <div>
        <div className="border-r-2 border-black pr-2 mr-2">
          <div className="border-b-2 border-black flex justify-between h-16" >
            <div className='flex justify-between items-center'>
              <div className="flex flex-col justify-center pb-4">
                <img src={logo} alt="" width="50%" />
                <div className='flex'>
                  <p className="font-light uppercase mr-3">Prescripción:</p>
                  <h5 className="font-bold flex-1">{prescription_num}</h5>
                </div>
              </div>
              <div className='mr-5'>
                <QRCodeCanvas
                  size={60}
                  value={link_qr}
                  level={"H"}
                />
              </div>
            </div>
            <div className="flex justify-center shrink-0 flex-col border-l pl-4 my-2">
              <h5 className="text-primary">{prefix} {formatFullname(professional)} </h5>
              <p className="block text-gray-500">Especialista en {specialtyString}</p>
                {licenses && <p className="text-gray-700 block">{(licenses[0] && `MP: ${licenses[0]}`)} - {(licenses[1] && `MP: ${licenses[1]}`)} {(licenses[2] && ` - ${licenses[2]}`)}</p>}
            </div>
          </div>
          <div className="">
            <div className="border-b border-black pb-2 flex items-center">
              <p className="font-light uppercase mr-3">Apellido y Nombres del afiliado</p>
              <h5 className="font-bold flex-1">{formatFullname(patient)}</h5>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="border-b border-black pb-2 flex items-center">
                <p className="font-light uppercase mr-3">Obra Social</p>
                <h5 className="font-bold flex-1">{patient.insurance_name}</h5>
              </div>
              <div className="border-b border-black pb-2 flex items-center">
                <p className="font-light uppercase mr-3">Afiliado</p>
                <h5 className="font-bold flex-1">{patient.insurance_number}</h5>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="border-b border-black pb-2 flex items-center">
                <p className="font-light uppercase mr-3">Fecha de emisión</p>
                <h5 className="font-bold flex-1">{date && date.toLocaleDateString()}</h5>
              </div>
              <div className="border-b border-black pb-2 flex w-full items-center">
                <p className="font-light uppercase mr-3">Duración</p>
                <h5 className="font-bold flex-1">{duration}</h5>
              </div>
            </div>
            <p className="font-light uppercase mr-3 mb-2">Medicamentos</p>
            <div className="border-b-2 border-black pb-2 h-8">
              <div className="flex items-stretch justify-between">
                <div className="flex">
                  <p className="font-light uppercase mr-3">RP./1</p>
                  <div>
                    <h5 className="font-bold">{medicament1.name}</h5>
                    <p className="font-light">{medicament1.drug}</p>
                    <p className="font-light">{medicament1.presentation}</p>
                    <p className="font-light italic mt-1">{medicament1.indications}</p>
                  </div>
                </div>
                <h5 className="font-bold"></h5>
                <div className="flex">
                  <p className="font-light mr-2">CANT.REC</p>
                  <h5 className="font-bold">{medicament1.quantity}</h5>
                </div>
              </div>
            </div>
            <div className="border-b-2 border-black pb-2 h-8">
              <div className="flex items-stretch justify-between">
                <div className="flex">
                  <p className="font-light uppercase mr-3">RP./2</p>
                  <div>
                    <h5 className="font-bold">{medicament2.name}</h5>
                    <p className="font-light">{medicament2.drug}</p>
                    <p className="font-light italic mt-1">{medicament2.indications}</p>
                  </div>
                </div>
                <h5 className="font-bold"></h5>
                <div className="flex">
                  <p className="font-light mr-2">CANT.REC</p>
                  <h5 className="font-bold">{medicament2.quantity}</h5>
                </div>
              </div>
            </div>
            <div className="flex border-b-2 border-black pb-2">
              <div className="w-3/5 border-r-2 border-black">
                <div className="border-b-2 border-black flex justify-items-start mr-2 pb-8 h-6">
                  <p className="font-light uppercase mr-2">Diagnóstico <br></br> RP./1</p>
                  <h5 className="font-bold">{diagnostic1.name}</h5>
                </div>
                <div className=" flex justify-items-start mr-2 pb-6 h-6">
                  <p className=" font-light uppercase mr-2">Diagnóstico<br></br> RP./2</p>
                  <h5 className="font-bold">{diagnostic2.name}</h5>
                </div>
              </div>
              <div className="flex justify-start items-center flex-col shrink-0 pl-4 pt-2">
                {professional.cover_image ? <img crossOrigin="anonymous" src={prof_signature64} alt="" width="70px" height="50px" /> : <div>Profesional sin firma</div>}
                <p className="font-bold">{prefix} {formatFullname(professional)}</p>
                <p>Especialista en {specialtyString}</p>
                {
                // (professional.license && professional.license2) !== undefined ?
                //   <p className="text-gray-700">M.P: {professional.license} - M.N: {professional.license2}</p> :
                  <>
                    {/* {(professional.license) && <p className="text-gray-700">M.P: {professional.license}</p>}
                    {(professional.license2) && <p className="text-gray-700">M.N: {professional.license2}</p>} */}
                    {licenses && <p className="text-gray-700 block">{(licenses[0] && `MP: ${licenses[0]}`)} - {(licenses[1] && `MP: ${licenses[1]}`)} {(licenses[2] && ` - ${licenses[2]}`)}</p>}
                  </>
                }
              </div>
            </div>
          </div>
        </div>
        <div className="">
          <div className="flex">
            <div className="w-48 h-28 bg-gray-200 flex items-center justify-center">QR</div>

            <div>
              <div className="flex w-80">
                <p className="border border-dashed border-black flex items-center justify-center w-full h-12 my-1 mx-1">
                  Troquel
                </p>
                <p className="border border-dashed border-black flex items-center justify-center w-full h-12 my-1 mx-1">
                  Troquel
                </p>
              </div>
              <div className="flex">
                <p className="border border-dashed border-black flex items-center justify-center w-full h-12 my-1 mx-1">
                  Troquel
                </p>
                <p className="border border-dashed border-black flex items-center justify-center w-full h-12 my-1 mx-1">
                  Troquel
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    )
  }

  return (
    <>
    <div className="hidden">
      <div className="mx-auto flex flex-row text-sm print-pdf pt-2 " id={htmlId || "print-pdf"}>
        <div className="flex flex-col">
          {duplicate && <PrescriptionDup />}
          {duplicate && <PrescriptionDup />}
          {!duplicate && <PrescriptionNoDup />}
        </div>
      </div>
    </div>
  </>
  )
}
